import { Form } from "react-bootstrap";
import "../style/RadioButton.css";

const RadioButton = (props) => {
  return (
    <div className="radio-button">
      <Form.Check type="radio" value={props.value} checked={props.checked} onChange={props.onChange} />
    </div>
  );
};

export default RadioButton;
